export default __webpack_public_path__ + "static/media/icon-node-tipo-jogo.d1c0a752.svg";